/**
 * Elements whose ICP value needs a caveat (Reef Guard #1829): manganese
 * precipitates, iron and iodine are consumed quickly — all three can read low
 * even when dosed (iodine also because labs report total iodine, not the
 * active species). Copy: icp.context.caveat.<element>.
 */

/** ICP keys → elements with a reading caveat (#1829), in a fixed order, without duplicates. */
const CAVEAT_ELEMENTS: ReadonlyArray<readonly [string, readonly string[]]> = [
  ['manganese', ['mn', 'manganese', 'mangan']],
  ['iron', ['fe', 'iron', 'eisen']],
  ['iodine', ['i', 'iodine', 'iod', 'jod']],
];

export function icpCaveatElements(keys: readonly string[]): string[] {
  const lower = new Set(keys.map((k) => k.trim().toLowerCase()));
  return CAVEAT_ELEMENTS.filter(([, aliases]) => aliases.some((a) => lower.has(a))).map(([element]) => element);
}
